module.exports = __webpack_public_path__ + "media/images/logos/logo-roche-02a634f9daa47176208c9cb64cdd1038.svg";